(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2104],{

/***/ 62037:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[shortname]",
      function () {
        return __webpack_require__(68745);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ EnterpriseGuide; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _A__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20932);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48261);







var EnterpriseGuide = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0 auto;display:flex;flex-direction:column;align-items:center;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";padding:56px 64px;justify-content:center;max-width:1120px;"),
        className: "enterprise-guide " + props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("p", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0;margin-block-start:36px;font-size:16px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";text-align:center;"),
                children: [
                    "有料契約限定のコンテンツです。",
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("br", {}),
                    "無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。"
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:40px;width:100%;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
                    src: "/static/images/enterprise/paywall.png"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:56px;display:flex;flex-direction:column;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .trialRequestUrl */ .d1,
                        passHref: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                size: "normal",
                                children: "無料トライアルに申し込む"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:16px;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_A__WEBPACK_IMPORTED_MODULE_2__.A, {
                            href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .loginPath */ .Qv,
                            decoration: "none",
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:16px;"),
                            children: "契約済みの方はログインしてください"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 88402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LineClamp; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var LineClamp = function(param) {
    var lineNumber = param.lineNumber, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, _justify = param.justify, justify = _justify === void 0 ? false : _justify, lineClampRef = param.lineClampRef, className = param.className, children = param.children, title = param.title;
    if (typeof lineNumber === "number") {
        lineNumber = {
            desktop: lineNumber,
            mobile: lineNumber
        };
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(justify ? "text-align: justify;" : "", " ", showAll || "\n          overflow: hidden;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: ".concat(lineNumber.desktop, ";\n          ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n            -webkit-line-clamp: ").concat(lineNumber.mobile, ";\n            line-height: 1.75;\n          }\n        ")),
        className: className,
        ref: lineClampRef,
        title: title,
        children: children
    });
};


/***/ }),

/***/ 30291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EnterpriseGuideTemplate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _common_Head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12912);
/* harmony import */ var _common_Template__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33431);
/* harmony import */ var _atoms_EnterpriseGuide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67910);





var EnterpriseGuideTemplate = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_common_Head__WEBPACK_IMPORTED_MODULE_1__/* .DefaultHead */ .UJ, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_common_Template__WEBPACK_IMPORTED_MODULE_2__/* .Template */ .Y, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_EnterpriseGuide__WEBPACK_IMPORTED_MODULE_3__/* .EnterpriseGuide */ .w, {})
            })
        ]
    });
};


/***/ }),

/***/ 68745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _shortname_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/api/company.ts
var api_company = __webpack_require__(58124);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./components/pages/company/CompanyPage.tsx + 25 modules
var CompanyPage = __webpack_require__(56337);
// EXTERNAL MODULE: ./pages/_error.tsx
var _error = __webpack_require__(61753);
// EXTERNAL MODULE: ./components/pages/company/molecules/domestic/CompanySummary.tsx + 5 modules
var CompanySummary = __webpack_require__(27544);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/atoms/LineClamp.tsx
var LineClamp = __webpack_require__(88402);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/Shareholders.tsx






var Shareholders = function(props) {
    var leads = props.shareholders.filter(function(s) {
        return s.lead;
    }).map(function(s) {
        return s.name;
    }).sort();
    var notLeads = props.shareholders.filter(function(s) {
        return !s.lead;
    }).map(function(s) {
        return s.name;
    }).sort();
    var shareholders = leads.concat(notLeads);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompanySummary/* SummaryLabel */.yF, {
                children: [
                    "株主",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* SummaryLabelAnnotation */.Kr, {
                        children: "（過去の株主を含む）"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClamp/* LineClamp */.x, {
                className: "shareholders",
                lineNumber: 3,
                title: shareholders.join(" / "),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:150%;color:", dist/* colors.black30 */.O9.black30, ";text-decoration:none;cursor:default;"),
                children: shareholders.map(function(s, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                        className: "shareholder",
                        children: [
                            i !== 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareholderDivider, {}),
                            s
                        ]
                    }, s);
                })
            })
        ]
    });
};
var ShareholderDivider = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";"),
        children: " / "
    });
};

// EXTERNAL MODULE: ./lib/number.ts
var number = __webpack_require__(41181);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/SummaryAmountWithCurrency.tsx




var SummaryAmountWithCurrency = function(props) {
    var ref;
    var ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:baseline;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "currency",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:16px;line-height:100%;margin-right:4px;vertical-align:bottom;"),
                children: props.currency
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "value",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:32px;line-height:75%;"),
                children: (ref1 = (ref = props.amount.value) === null || ref === void 0 ? void 0 : ref.toFixed(1)) !== null && ref1 !== void 0 ? ref1 : "-"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "unit",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:16px;line-height:100%;margin-left:4px;vertical-align:bottom;"),
                children: props.amount.unit
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/ValuationInfo.tsx








var ValuationInfo = function(props) {
    if (!props.valuation) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "valuation",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:flex-start;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabel, {
                children: "調達後評価額"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "value",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:32px;height:48px;display:flex;align-items:center;line-height:75%;"),
                children: "-"
            })
        ]
    });
    var unitNumber = (0,number/* toUnitNumber */.Fk)(props.valuation.value);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "valuation",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;width:176px;flex-direction:column;align-items:center;justify-content:flex-start;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabel, {
                children: "調達後評価額"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "values",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:48px;flex-direction:row;align-items:center;justify-content:center;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryAmountWithCurrency, {
                    amount: unitNumber,
                    currency: props.valuation.currency
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* DateNote */.hK, {
                date: props.valuation.date,
                suffix: "時点",
                className: "date"
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/company.ts
var company = __webpack_require__(10133);
// EXTERNAL MODULE: ./components/common/Help.tsx
var Help = __webpack_require__(33869);
// EXTERNAL MODULE: ./lib/roundtype.ts
var roundtype = __webpack_require__(39250);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/RoundType.tsx








var RoundType = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:flex-start;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                children: [
                    "最新ラウンドタイプ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                        className: "help",
                        linkTo: "https://help.initial.inc/ja/articles/5489432",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("vertical-align:bottom;"),
                        children: "定義を見る"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "value",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:48px;font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:22px;line-height:100%;align-items:center;text-align:center;color:", dist/* colors.black10 */.O9.black10, ";"),
                children: props.company.lastFundingType == null ? "-" : (0,roundtype/* formatLastFundingType */.e)(props.company.lastFundingType.type)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* DateNote */.hK, {
                className: "date",
                date: props.company.lastFundingType && props.company.lastFundingType.date,
                suffix: "時点"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/EmployeesNumber.tsx





var EmployeesNumber = function(props) {
    var hasValue = props.start || props.end;
    var _start, _end;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:flex-start;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabel, {
                children: "従業員数"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:32px;height:48px;line-height:75%;text-align:center;display:flex;align-items:center;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:baseline;"),
                    children: [
                        hasValue ? "".concat((_start = props.start) !== null && _start !== void 0 ? _start : "", "-").concat((_end = props.end) !== null && _end !== void 0 ? _end : "") : "-",
                        hasValue && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;font-size:16px;line-height:100%;margin-left:4px;vertical-align:bottom;"),
                            children: "人"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/company/molecules/Description.tsx
var Description = __webpack_require__(46923);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/IpoValuationInfo.tsx








var IpoValuationInfo = function(props) {
    if (!props.ipoData || !props.ipoData.valuation.value || !props.ipoData.valuation.currency) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "ipo-valuation",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:flex-start;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                    children: [
                        "IPO時時価総額",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* SummaryLabelAnnotation */.Kr, {
                            children: "（公開価格）"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "value",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:32px;height:48px;display:flex;align-items:center;line-height:75%;"),
                children: "-"
            })
        ]
    });
    var unitNumber = (0,number/* toUnitNumber */.Fk)(props.ipoData.valuation.value);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "ipo-valuation",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;width:176px;flex-direction:column;align-items:center;justify-content:flex-start;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                    children: [
                        "IPO時時価総額",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* SummaryLabelAnnotation */.Kr, {
                            children: "（公開価格）"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "values",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:48px;flex-direction:row;align-items:center;justify-content:center;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryAmountWithCurrency, {
                    amount: unitNumber,
                    currency: props.ipoData.valuation.currency
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/sticky.ts
var sticky = __webpack_require__(76830);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasCompanySummary.tsx














var OverseasCompanySummary = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanyHero, {
                company: props.company
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;max-width:1200px;margin:0 auto;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{padding:50px 20px 10px;}", dist.mq.large, "{margin-left:212px;margin-bottom:24px;min-height:64px;}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
                                company: props.company
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:10px;"),
                                children: props.company.tags.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
                                    className: "tag-list",
                                    children: props.company.tags.map(function(tag, i) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                            tag: tag
                                        }, i);
                                    })
                                }) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                        dashed: true,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:90%;margin:5px auto;", dist.mq.large, "{display:none;}")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopInfo, {
                        company: props.company
                    })
                ]
            })
        ]
    });
};
var OverseasCompanyHero = function(props) {
    var ref = (0,react.useState)(false), isCompanySummaryStickyPosition = ref[0], setIsCompanySummaryStickyPosition = ref[1];
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function() {
            setIsCompanySummaryStickyPosition(sticky/* checkSummaryStickyPosition */.t);
        });
        return function() {
            window.removeEventListener("scroll", function() {
                setIsCompanySummaryStickyPosition(sticky/* checkSummaryStickyPosition */.t);
            });
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* EyecatchBg */.CB, {
        tags: [],
        sticky: isCompanySummaryStickyPosition,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{margin-block-start:24px;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-end;width:100%;max-width:", isCompanySummaryStickyPosition && "1120px", ";margin-block-start:auto;margin-inline:auto;padding-inline:", isCompanySummaryStickyPosition ? "0" : "80px", ";color:", dist/* colors.white00 */.O9.white00, ";"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:", isCompanySummaryStickyPosition ? "center" : "end", ";column-gap:", isCompanySummaryStickyPosition ? "16px" : "32px", ";min-width:0;min-height:", isCompanySummaryStickyPosition ? "96px" : "80px", ";"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-grow:0;flex-shrink:0;margin-block-end:", isCompanySummaryStickyPosition ? "0" : "-80px", ";"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                            className: "logo",
                            name: props.company.name,
                            src: props.company.logoUrl || (0,company/* companyDefaultImage */.tP)("未公開企業"),
                            size: isCompanySummaryStickyPosition ? "normal" : "extra-large",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{width:96px !important;height:96px !important;}")
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyName, {
                        isIpo: props.company.listed,
                        isCompanySummaryStickyPosition: isCompanySummaryStickyPosition,
                        children: props.company.name
                    })
                ]
            })
        })
    });
};
var CompanyName = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;flex-grow:1;min-width:0;", dist.mq.large, "{display:flex;flex-direction:column;row-gap:2px;padding-block-end:", props.isCompanySummaryStickyPosition ? "0" : "8px", ";}"),
            children: [
                props.isIpo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tag */.Vp, {
                        className: "ipo-label",
                        inverted: true,
                        square: true,
                        color: "red",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;"),
                        children: "IPO"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;font-size:20px;color:", dist/* colors.white00 */.O9.white00, ";font-size:", props.isCompanySummaryStickyPosition ? "28px" : "32px", ";text-decoration:none;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.25;letter-spacing:0.01em;overflow-wrap:break-word;transition:font-size 0.16s 0s linear;", props.isCompanySummaryStickyPosition && "text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"),
                    children: props.children
                })
            ]
        })
    });
};
var TopInfo = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", dist.mq.large, "{padding-left:20px;flex-direction:row;min-height:82px;margin-bottom:28px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:160px;min-width:160px;margin-right:32px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoundType, {
                    className: "last-funding-type",
                    company: props.company
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:176px;margin-right:16px;"),
                "data-test-id": "overview-valuation",
                children: props.company.listed ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IpoValuationInfo, {
                    ipoData: props.company.ipo
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ValuationInfo, {
                    valuation: props.company.valuation
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:176px;margin-right:16px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmployeesNumber, {
                    className: "employees_num",
                    start: props.company.employee.range.start,
                    end: props.company.employee.range.end
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Shareholders, {
                    shareholders: props.company.shareholders
                })
            })
        ]
    });
};
var SummaryLabel = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-style:normal;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";height:18px;font-size:13px;display:flex;text-align:center;align-items:center;"),
        children: props.children
    });
};

// EXTERNAL MODULE: ./components/atoms/CardTitle.tsx
var CardTitle = __webpack_require__(4336);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/DoubleColumnContent.tsx



var DoubleColumnContent = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Content */.Zb.Content, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:32px !important;display:flex;flex-direction:column;", dist.mq.large, "{flex-direction:row;> dl{width:50%;&:last-of-type{padding-left:1rem;}}}"),
        children: props.children
    });
};

// EXTERNAL MODULE: ./components/atoms/DescriptionList.tsx
var DescriptionList = __webpack_require__(53156);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverviewAmountWithCurrency.tsx




var OverviewAmountWithCurrency = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "values",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
        children: props.amount ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;flex-direction:row;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "currency",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:13px;margin-right:4px;"),
                    children: props.currency
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "value",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:20px;"),
                    children: props.amount.value.toFixed(1)
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "unit",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:13px;margin-left:4px;vertical-align:bottom;"),
                    children: props.amount.unit
                })
            ]
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "value",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:20px;padding-right:80px;"),
            children: "-"
        })
    });
};

// EXTERNAL MODULE: ./components/pages/company/molecules/EmptyNumber.tsx
var EmptyNumber = __webpack_require__(62610);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/FinanceInfoItem.tsx





var FinanceInfoItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-start;justify-content:space-between;flex-basis:50%;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:13px;margin-top:5px;"),
                        children: props.label
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:13px;margin-top:5px;"),
                        children: props.labelAnnotation
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:2;padding-left:40px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("line-height:1.2;"),
                        children: props.value || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyNumber/* EmptyNumber */.y, {})
                    }),
                    props.valueAnnotationDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "date",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;color:", dist/* colors.textLight */.O9.textLight, ";margin-top:4px;"),
                        children: [
                            props.valueAnnotationDesc,
                            "：",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;color:", dist/* colors.textLight */.O9.textLight, ";"),
                                children: props.valueAnnotationDate
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:166px;")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/company/molecules/DatasourceLink.tsx
var DatasourceLink = __webpack_require__(56279);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasCompanyOverview.tsx













var OverseasCompanyOverview = function(param) {
    var company = param.company;
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "overview",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                    href: "https://help.initial.inc/ja/articles/5358443",
                    className: "about-data-source"
                }),
                children: "企業概要"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                "国・地域": {
                                    text: company.country || "",
                                    extraClassName: "country"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            className: "company-type",
                            list: {
                                タイプ: {
                                    text: "未公開企業",
                                    extraClassName: "type"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:1px solid ", dist/* colors.border */.O9.border, ";border-bottom:1px solid ", dist/* colors.border */.O9.border, ";"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:32px;justify-content:space-between;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinanceInfoItem, {
                        className: "total-funding",
                        label: "総調達額",
                        value: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewAmountWithCurrency, {
                            amount: company.totalFundraise ? (0,number/* toUnitNumber */.Fk)(company.totalFundraise.value) : null,
                            currency: company.totalFundraise ? company.totalFundraise.currency : ""
                        }),
                        valueAnnotationDesc: "最新対象ラウンド",
                        valueAnnotationDate: company.totalFundraise && ((ref = company.totalFundraise) === null || ref === void 0 ? void 0 : ref.date) ? (0,date/* formatDate */.p6)(company.totalFundraise.date, "yyyy/MM/dd") : null
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/Template.tsx
var Template = __webpack_require__(33431);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasIpoCompanyOverview.tsx














var OverseasIpoCompanyOverview = function(param) {
    var company = param.company;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "overview",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                right: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatasourceLink/* DatasourceLink */.I, {
                    href: "https://help.initial.inc/ja/articles/5358443",
                    className: "about-data-source"
                }),
                children: "企業概要"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                "国・地域": {
                                    text: company.country || "",
                                    extraClassName: "country"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            className: "ipo-date company-type",
                            list: {
                                タイプ: {
                                    text: "IPO企業",
                                    extraClassName: "type"
                                },
                                IPO年月日: {
                                    text: company.ipo ? (0,date/* formatDate */.p6)((ref = company.ipo) === null || ref === void 0 ? void 0 : ref.date, "yyyy/MM/dd") : "",
                                    extraClassName: "date"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:1px solid ", dist/* colors.border */.O9.border, ";border-bottom:1px solid ", dist/* colors.border */.O9.border, ";"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:32px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "ipo-valuation",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:50%;display:flex;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:space-between;flex:1;"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-bottom:12px;font-size:14px;"),
                                        children: [
                                            "IPO時時価総額",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* SummaryLabelAnnotation */.Kr, {
                                                children: "（公開価格）"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display;flex;flex:2;padding-left:40px;"),
                                    children: company.ipo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewAmountWithCurrency, {
                                        amount: company.ipo.valuation.value ? (0,number/* toUnitNumber */.Fk)((ref1 = company.ipo) === null || ref1 === void 0 ? void 0 : ref1.valuation.value) : null,
                                        currency: company.ipo.valuation.currency ? company.ipo.valuation.currency : ""
                                    }) : null
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:space-between;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FinanceInfoItem, {
                                className: "total-funding",
                                label: "総調達額",
                                value: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewAmountWithCurrency, {
                                    amount: company.totalFundraise ? (0,number/* toUnitNumber */.Fk)(company.totalFundraise.value) : null,
                                    currency: company.totalFundraise ? company.totalFundraise.currency : ""
                                }),
                                valueAnnotationDesc: "最新対象ラウンド",
                                valueAnnotationDate: company.totalFundraise && ((ref2 = company.totalFundraise) === null || ref2 === void 0 ? void 0 : ref2.date) ? (0,date/* formatDate */.p6)(company.totalFundraise.date, "yyyy/MM/dd") : null
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./lib/collection.ts
var collection = __webpack_require__(67064);
;// CONCATENATED MODULE: ./lib/formatter.ts

var formatNumberWithUnit = function(num) {
    var unitNumber = (0,number/* toUnitNumber */.Fk)(num);
    return "".concat(unitNumber.value).concat(unitNumber.unit);
};
var ommitText = function(s, len) {
    return s.length > len ? "".concat(s.substring(0, len), "...") : s;
};

// EXTERNAL MODULE: ./components/atoms/CardInnerTitle.tsx
var CardInnerTitle = __webpack_require__(73367);
// EXTERNAL MODULE: ./components/atoms/Table.tsx
var Table = __webpack_require__(14792);
// EXTERNAL MODULE: ./components/common/OpenCloseToggle.tsx
var OpenCloseToggle = __webpack_require__(63043);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasComapnyFundingRoundInvestments.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  padding: 0px;\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  padding: 12px 8px;\n                "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var OverseasCompanyFundingRoundInvestments = function(param) {
    var investments = param.investments;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0 8px 0 40px;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
            className: "investments-table",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHead */.ss, {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:32px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("th{padding:0px 8px;font-size:12px;color:", dist/* colors.textLight */.O9.textLight, ";}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                width: "24px"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                width: "584px",
                                children: "投資家名"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                width: "232px",
                                justify: "end"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                width: "224px"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                    children: investments.map(function(investment) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableRow */.SC, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    centerized: true,
                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject()),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "box-drawing-character"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1()),
                                    children: investment.globalId ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        href: "/investors/".concat(investment.globalId),
                                        target: "_blank",
                                        rel: "noopener",
                                        decoration: "none",
                                        children: investment.name
                                    }) : investment.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {})
                            ]
                        }, investment.investmentId);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasCompanyFundingRounds.tsx


function OverseasCompanyFundingRounds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    td {\n                      padding: 16px;\n                    }\n                  "
    ]);
    OverseasCompanyFundingRounds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var OverseasCompanyFundingRounds = function(param) {
    var overseaFundingRounds = param.overseaFundingRounds;
    var ref = (0,react.useState)([]), openingIndexes = ref[0], setOpeningIndexes = ref[1];
    var roundWithDetailsIndexes = overseaFundingRounds.reduce(function(acc, curr, idx) {
        return curr.investments.length > 0 ? acc.concat(idx) : acc;
    }, Array(0));
    var toggleRoundDetails = function(index) {
        if (isRoundOpen(index)) {
            setOpeningIndexes(function(pre) {
                return pre.filter(function(s) {
                    return s !== index;
                });
            });
        } else {
            setOpeningIndexes(function(pre) {
                return (0,_to_consumable_array/* default */.Z)(pre).concat([
                    index
                ]);
            });
        }
    };
    var isRoundOpen = function(index) {
        return openingIndexes.includes(index);
    };
    var toggleAllRoundDetails = function() {
        if (isAllRoundsOpen) {
            setOpeningIndexes([]);
        } else {
            setOpeningIndexes(roundWithDetailsIndexes);
        }
    };
    var hasRoundWithDetails = roundWithDetailsIndexes.length !== 0;
    var isAllRoundsOpen = hasRoundWithDetails && (0,collection/* equal */.Dg)(roundWithDetailsIndexes, openingIndexes);
    var buttonLabel = !hasRoundWithDetails ? "" : isAllRoundsOpen ? "すべて閉じる" : "すべて開く";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "ラウンド情報"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                className: "round-table",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHead */.ss, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:48px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("th{padding:16px;}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    width: "40px",
                                    align: "center",
                                    justify: "center",
                                    className: "toggle",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                                        label: buttonLabel,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenCloseToggle/* OpenCloseToggle */.m, {
                                            status: isAllRoundsOpen ? "open" : hasRoundWithDetails ? "closed" : "disabled",
                                            onClick: toggleAllRoundDetails,
                                            isLarge: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    width: "104px",
                                    children: "発表日"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    width: "504px",
                                    help: "定義を見る",
                                    helpProps: {
                                        linkTo: "https://help.initial.inc/ja/articles/5489432"
                                    },
                                    children: "最新ラウンドタイプ"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    width: "232px",
                                    justify: "end",
                                    children: "調達金額"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    width: "232px",
                                    justify: "end",
                                    children: "調達後評価額"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("tr:last-child td{border-bottom:none;}"),
                        children: overseaFundingRounds.map(function(fr, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableRow */.SC, {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(OverseasCompanyFundingRounds_templateObject()),
                                        className: "round-table-row",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                className: "toggle",
                                                centerized: true,
                                                children: fr.investments.length !== 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenCloseToggle/* OpenCloseToggle */.m, {
                                                    status: isRoundOpen(i) ? "open" : "closed",
                                                    onClick: function() {
                                                        return toggleRoundDetails(i);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: fr.valuationDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                    children: fr.valuationDate
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: fr.roundType && (0,roundtype/* formatLastFundingType */.e)(fr.roundType)
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                align: "right",
                                                children: fr.raisedAmountUsd && "USD ".concat(formatNumberWithUnit(fr.raisedAmountUsd))
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                align: "right",
                                                children: fr.valuationUsd && "USD ".concat(formatNumberWithUnit(fr.valuationUsd))
                                            })
                                        ]
                                    }, fr.fundingRoundId),
                                    isRoundOpen(i) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            colSpan: 5,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanyFundingRoundInvestments, {
                                                investments: fr.investments
                                            })
                                        })
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasCompanyFinance.tsx



var OverseasCompanyFinance = function(param) {
    var overseaFundingRounds = param.overseaFundingRounds;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "finance",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                children: "ファイナンス"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanyFundingRounds, {
                overseaFundingRounds: overseaFundingRounds
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/common/Navbar.tsx
var Navbar = __webpack_require__(3511);
;// CONCATENATED MODULE: ./components/pages/company/molecules/oversea/OverseasCompanyTabGroup.tsx

function OverseasCompanyTabGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                ",
        " {\n                  font-size: 14px;\n                  height: 32px;\n                }\n              "
    ]);
    OverseasCompanyTabGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var OverseasCompanyTabGroup = function(props) {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Navbar */.w, {
        "data-test-id": "tab-group",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:7px 16px;height:48px;", dist.mq.large, "{height:auto;padding:11px 0;position:sticky;top:160px;z-index:19;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:1200px;margin:0 auto;display:flex;align-items:center;white-space:nowrap;"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tab.Group */.OK.Group, {
                children: overseaCompanyTabList.map(function(tab, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tab */.OK, {
                        active: props.activeTab == tab,
                        href: "".concat(router.query.shortname, "#").concat(tab),
                        css: (0,emotion_react_browser_esm/* css */.iv)(OverseasCompanyTabGroup_templateObject(), dist.mq.untilMedium),
                        children: company/* companyTabLabel */.vg[tab]
                    }, "oversea-".concat(tab, "-").concat(i));
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./components/pages/company/molecules/domestic/CompanyInviewForActiveTab.tsx
var CompanyInviewForActiveTab = __webpack_require__(82263);
// EXTERNAL MODULE: ./components/common/InviewForActiveTab.tsx
var InviewForActiveTab = __webpack_require__(53565);
;// CONCATENATED MODULE: ./components/pages/company/OverseasCompanyPage.tsx
















var overseaCompanyTabList = [
    "basic-info",
    "finance-info", 
];
var ref = (0,_sliced_to_array/* default */.Z)((0,InviewForActiveTab/* createInViewEventQueue */.ze)(), 2), push = ref[0], apply = ref[1];
var OverseasCompanyPage = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,InviewForActiveTab/* setupActiveTabs */.ji)(overseaCompanyTabList), 2), init = ref[0], first = ref[1];
    var ref1 = (0,react.useState)(init()), activeTabs = ref1[0], setActiveTabs = ref1[1];
    var handleChangeActive = function(tab, inView) {
        push(tab, inView, onTimeout);
    };
    var onTimeout = function() {
        setActiveTabs(apply(activeTabs));
    };
    if (!props.company) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_error["default"], {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* OverseasCompanyHead */.SG, {
                company: props.company,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "viewport",
                    content: "width=1200px"
                }, "viewport")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Template/* Template */.Y, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanySummary, {
                        company: props.company
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanyTabGroup, {
                        activeTab: first(activeTabs)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";padding-bottom:55px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:1200px;margin:0 auto;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-bottom:2rem;"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                            tabName: "basic-info",
                                            onChangeActive: handleChangeActive,
                                            offset: "-5rem",
                                            mobileOffset: "-5rem",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-block-start:24px;", dist.mq.untilMedium, "{padding-block:0px;}"),
                                            children: props.company.listed ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasIpoCompanyOverview, {
                                                company: props.company
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanyOverview, {
                                                company: props.company
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyInviewForActiveTab/* CompanyInviewForActiveTab */.y, {
                                            tabName: "finance-info",
                                            onChangeActive: handleChangeActive,
                                            offset: "-5rem",
                                            mobileOffset: "-5rem",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-block-start:40px;", dist.mq.untilMedium, "{padding-top:0px;}"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasCompanyFinance, {
                                                overseaFundingRounds: props.company.overseaFundingRounds
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        className: "powered-by",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;"),
                                        children: [
                                            "Powered by",
                                            " ",
                                            props.company.crunchbaseUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                href: props.company.crunchbaseUrl,
                                                decoration: "none",
                                                target: "_blank",
                                                children: "Crunchbase"
                                            }) : "Crunchbase"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var company_OverseasCompanyPage = (OverseasCompanyPage);

// EXTERNAL MODULE: ./components/view/EnterpriseGuide.tsx
var EnterpriseGuide = __webpack_require__(30291);
// EXTERNAL MODULE: ./lib/api/contentful.ts
var contentful = __webpack_require__(58585);
// EXTERNAL MODULE: ./lib/api/smartround.ts
var smartround = __webpack_require__(43585);
;// CONCATENATED MODULE: ./pages/companies/[shortname].tsx















var CompanyShortnamePage = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    return props.oversea ? (0,lib_user/* isTrial */.pN)(user) || (0,lib_user/* isEnterprise */.ko)(user) && (0,lib_user/* isLatestPlan */.br)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(company_OverseasCompanyPage, {
        company: props.company
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseGuide/* EnterpriseGuideTemplate */.P, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyPage/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        company: props.company
    }));
};
CompanyShortnamePage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var ref, shortname, company, reCaptchaEnabled, slideBannerArticles, staticBanners, floatingBanner, smartroundUrl, companyMemo, companyStatus, companyContactPerson, ref1, isDomestic;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    shortname = ctx.query.shortname;
                    return [
                        4,
                        (0,api_company/* fetchCompany */.Mn)(ctx, shortname)
                    ];
                case 1:
                    company = _state.sent();
                    reCaptchaEnabled = ((ref = ctx.req) === null || ref === void 0 ? void 0 : ref.headers["x-datadog-synthetics-monitoring"]) === "true" ? false : true;
                    slideBannerArticles = null;
                    staticBanners = null;
                    floatingBanner = null;
                    smartroundUrl = null;
                    companyMemo = {
                        memo: null
                    };
                    companyStatus = {
                        companyStatus: null
                    };
                    companyContactPerson = {
                        contactPerson: null
                    };
                    if (!!(company === null || company === void 0 ? void 0 : company.oversea)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            (0,contentful/* getNpStartupSlideBannerArticles */.V6)(),
                            (0,contentful/* getNpStartupStaticBanner */.yy)(),
                            (0,contentful/* getNpStartupFloatingBanner */.T4)(),
                            (0,smartround/* getSmartroundUrl */.m)(ctx, company !== null ? company.corporateNumber : null),
                            (0,api_company/* getCompanyMemo */.t1)(ctx, shortname),
                            (0,api_company/* getCompanyStatus */.jy)(ctx, shortname),
                            (0,api_company/* getCompanyContactPerson */.QU)(ctx, shortname)
                        ])
                    ];
                case 2:
                    ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        7
                    ]), slideBannerArticles = ref1[0], staticBanners = ref1[1], floatingBanner = ref1[2], smartroundUrl = ref1[3], companyMemo = ref1[4], companyStatus = ref1[5], companyContactPerson = ref1[6], ref1;
                    _state.label = 3;
                case 3:
                    isDomestic = true;
                    if (shortname !== undefined) {
                        isDomestic = shortname.startsWith("A-");
                    }
                    return [
                        2,
                        {
                            company: company,
                            oversea: !isDomestic,
                            slideBannerArticles: slideBannerArticles,
                            staticBanners: staticBanners,
                            floatingBanner: floatingBanner,
                            smartroundUrl: smartroundUrl,
                            companyMemo: companyMemo.memo,
                            companyStatus: companyStatus.companyStatus,
                            companyContactPerson: companyContactPerson.contactPerson,
                            reCaptchaEnabled: reCaptchaEnabled
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _shortname_ = (CompanyShortnamePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,8687,519,8674,8101,9198,6066,5998,774,3431,3954,9635,8328,9967,9871,655,8331,6337,2888,179], function() { return __webpack_exec__(62037); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);